import React from "react";
import Sidebar from "./../components/sidebar";
import Header from "./../components/Header";
import {useDispatch, useSelector} from "react-redux";
import EditUserMain from "../components/users/EditUserMain";

const ClientEditScreen = () => {


    const clientById = useSelector((state) => state.userLogin);
    const {userInfo} = clientById;
    console.log(userInfo._id);



    return (
        <>
            <Sidebar />
            <main className="main-wrap">
                <Header />
                {userInfo && <EditUserMain user={userInfo} />
                }
            </main>
        </>
    );
};
export default ClientEditScreen;
